<template>
  <v-menu
    v-model="shownPresentor"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
    ref="refMenu"
  >
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom :disabled="disablePresentorTip">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn small icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
            <v-icon size="20" color="neutralGray">mdi-account-edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("agenda.tipChangePresentor") }}</span>
      </v-tooltip>
    </template>
    <v-banner color="primaryLight1" sticky single-line tile>
      <v-toolbar color="primaryLight1">
        <span> {{ $t("agenda.tipChangePresentor") }}</span>
        <v-spacer></v-spacer>
        <CloseIcon @click="close()" />
      </v-toolbar>
    </v-banner>
    <v-card>
      <v-card-text style="color: black" class="pa-0">
        <v-list
          ref="myList"
          dense
          class="pt-0 overflow-y-auto"
          style="max-height: 25vh"
        >
          <v-list-item
            v-for="(item, index) in presentorList"
            :key="index"
            :class="{ selected: item.checked }"
          >
            <v-list-item-action class="mr-1">
              <v-checkbox
                v-model="item.checked"
                @change="selectPresentor(item)"
                dense
              ></v-checkbox>
            </v-list-item-action>
            <v-list-item-avatar size="32" class="mr-4 ml-2">
              <v-img
                v-if="item.profilePhoto"
                contain
                :src="item.profilePhoto"
              ></v-img>
              <v-img
                v-else
                contain
                src="@/assets/images/NoPhotoIcon.png"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-content class="text-max-width">
              <v-list-item-title
                v-if="item.isInterimPresentor"
                class="label-m text-truncate"
                style="height: 18px"
              >
                <span>{{ item.firstName }}</span>
              </v-list-item-title>
              <v-list-item-title v-else class="label-m text-truncate">
                <span v-if="item.firstName">
                  {{ item.firstName + " " + item.lastName }}
                </span>
                <span v-else>{{ item.email }}</span>
              </v-list-item-title>
              <v-list-item-subtitle
                v-if="item.title"
                class="label-s text-truncate"
              >
                <span>{{ item.title }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="item.isInterimPresentor">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <a-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    small
                    @click.stop="deletePresentor(item.id)"
                  >
                    <v-icon> mdi-delete</v-icon>
                  </a-btn>
                </template>
                <span>{{ $t("presentor.deleteInterimPresentor") }}</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
          <add-interim-presentor
            v-if="showAddInterimDialog"
            ref="scrollItem"
            @onAdd="onAdd"
          ></add-interim-presentor>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              text
              color="primary"
              :disabled="showAddInterimDialog"
              @click="addInetrimPresentorPanel"
            >
              <v-icon small>mdi-plus</v-icon
              >{{ $t("presentor.addInterimPresentor") }}
            </v-btn>
          </template>
          <span> {{ $t("presentor.addInterimPresentor") }} </span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import AddInterimPresentor from "./AddInterimPresentor.vue";
import { cloneDeep } from "lodash";

export default {
  components: { AddInterimPresentor },
  name: "PresentorDropdownList",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selectedItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showAddOption: false,
      showAddInterimDialog: false,
      shownPresentor: false,
      disablePresentorTip: false,
    };
  },
  watch: {
    shownPresentor(value) {
      if (value) {
        this.disablePresentorTip = true;
      } else {
        this.disablePresentorTip = false;
        this.showAddInterimDialog = false;
        setTimeout(() => {
          this.scrollToTop();
        }, 50);
      }
    },
  },
  computed: {
    presentorList() {
      return this.items.map((obj) => ({
        ...obj,
        checked: this.listSelection.includes(obj.id),
      }));
    },
    listSelection() {
      return this.selectedItem.peopleInCharge;
    },
  },
  methods: {
    close() {
      this.shownPresentor = false;
    },
    scrollToTop() {
      const menuRef = this.$refs.refMenu.$refs.content;
      if (menuRef) {
        menuRef.querySelector(".v-list").scrollTop = 0;
      }
    },
    deletePresentor,
    scrollToEnd,
    onAdd,
    addInetrimPresentorPanel,
    selectPresentor,
  },
};

function selectPresentor(item) {
  const listSelection = cloneDeep(this.listSelection);
  const index = listSelection.findIndex((id) => id === item.id);
  if (index === -1) {
    listSelection.push(item.id);
  } else {
    listSelection.splice(index, 1);
  }
  this.selectedItem.peopleInCharge = listSelection;
  this.$emit("onSelection", this.selectedItem);
}

function addInetrimPresentorPanel() {
  this.showAddInterimDialog = true;
  this.scrollToEnd();
}

function onAdd() {
  this.showAddInterimDialog = false;
  // this.showAddOption = true;
  // // setTimeout(() => {
  // this.scrollToEnd();
  // // }, 500);
}

function scrollToEnd() {
  // Wait for the DOM to update after adding new items
  this.$nextTick(() => {
    const list = this.$refs.myList.$el; // Reference to v-list
    list.scrollTop = Number(list.scrollHeight) + 60; // Scroll to the end
  });
}

function deletePresentor(id) {
  this.$emit("remove", id);
}
</script>

<style scoped>
.text-max-width {
  max-width: 280px;
}

.selected {
  background-color: #f0f0f0; /* or any other style to indicate selection */
}
</style>